import React, { useEffect } from 'react'
import './Home.css'
import { Button } from '@mui/material'
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
function Home({ user, pop }) {
  const Navigateto = useNavigate()
  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (!user) {
        Navigateto("/");
      }
    });
  }, [user]);
  return (
      <div className='Home'>
          <div className='Content'>
              <h2>{user ?'Start wishlisting your favourite movies to watch':'Login in to wishlist the movies you want to watch'}</h2>
          
     
        <Button onClick={ pop} className='button'>
           <span></span>
      <span></span>
      <span></span>
      <span></span>{user?`Welcome ${user.displayName}`:`log in`}</Button>
        </div>
      </div>
          
   
  )
}

export default Home